<template>
  <div class="c-language" :class="{ _showMenu: isMenuShow }">
    <button class="c-language__button" @click="showMenu">
      <picture>
        <source
          media="(max-width: 767px)"
          :srcset="path + 'img/common/icon_language_sp.svg'"
        />
        <img
          :src="path + 'img/common/icon_language.svg'"
          alt=""
          width="30"
          height="30"
          decoding="async"
          class="c-language__image"
        />
      </picture>
      <span class="c-language__text u-uppercase" lang="en">Language</span>
    </button>
    <transition name="list">
      <ul v-show="isMenuShow" class="c-language__list">
        <slot name="language-list"></slot>
      </ul>
    </transition>
    <transition name="overlay">
      <div v-show="isMenuShow" class="c-language__overlay"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LanguageButton',
  data() {
    return {
      isMenuShow: false,
      path: '',
    };
  },
  mounted() {
    window.addEventListener('scroll', () => {
      if (this.isMenuShow) {
        this.closeMenu();
      }
    });
    if (window.paths) {
      this.path = `${window.paths.stylesheet_directory_uri}/frontend/dist/`;
    }
  },
  methods: {
    showMenu() {
      this.isMenuShow = !this.isMenuShow;
    },
    closeMenu() {
      this.isMenuShow = false;
    },
  },
};
</script>
